import React, { FC, useContext } from 'react';
import { observer } from 'mobx-react';
import styles from './FilterSection.module.scss';
import { AppStoreContext } from '../../Stores/AppStore';
import { Select } from '../Select/Select';

type Props = {
    isGlobalRole: boolean;
}
export const FilterSection: FC<Props> = observer(({isGlobalRole}) => {
    const { filtersStore } = useContext(AppStoreContext);

    const {
        isLoading,
        onOrganizationsChange, organizationOptions,
        selectedOrganizationOption
    } = filtersStore;

    if(!isGlobalRole || !organizationOptions.length) return null;

    return (
        <div className={styles.root}>
            <div className={styles.item}>
                <Select
                    label="Organization"
                    isLoading={isLoading.isPending}
                    value={selectedOrganizationOption || null}
                    isClearable={true}
                    onChange={sel=>{
                        onOrganizationsChange(sel?.value || '')
                    }}
                    options={organizationOptions}
                />
            </div>
        </div>
    );
});